export default {
  install(Vue, store) {
    Vue.prototype.$alert = function (title, type) {
      return this.$root.$emit("alert", { title, type });
    };

    Object.defineProperty(Vue.prototype, "$settings", {
      get() {
        return store.state.settings;
      },
    });
  },
};
